import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SocialiconPageRoutingModule } from './socialicon-routing.module';
import { SocialiconPage } from './socialicon.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SocialiconPageRoutingModule,
    TranslateModule
  ],
  declarations: [SocialiconPage]
})
export class SocialiconPageModule {}
